<template>
    <form
        action=""
        class="mt-4 mb-5"
        @submit.prevent="onSubmit"
        enctype="multipart/form-data"
    >
        <div class="form-group">
            <label for="title">Title About Template</label>
            <input
                type="text"
                class="form-control form-control-lg"
                placeholder="Title here..."
                v-model="form.title"
                :class="{ 'is-invalid': error.title }"
                @keypress="error.title = null"
            />
            <div class="invalid-feedback" v-if="error.title">
                {{ error.title[0] }}
            </div>
        </div>
        <div class="form-group">
            <label for="title">Details about the template</label>
            <textarea
                name="details"
                rows="6"
                class="form-control form-control-lg"
                v-model="form.details"
                :class="{ 'is-invalid': error.details }"
                @keypress="error.details = null"
                placeholder="Be as detailed as you can"
            />
            <div class="invalid-feedback" v-if="error.details">
                {{ error.details[0] }}
            </div>
        </div>
        <div class="form-group">
            <input
                type="file"
                ref="file"
                style="display: none"
                @change="changeFile($event)"
            />
            <div v-if="attachment_name">
                {{ attachment_name }}
            </div>
            <button
                @click.prevent="$refs.file.click()"
                class="btn btn-text"
                style="padding-left: 0"
            >
                <i class="fa fa-paperclip"></i>&nbsp;&nbsp;
                <span
                    >Attach a file (Optional but attachment size must be below
                    5MB if provided)</span
                >
            </button>
            <div
                class="invalid-feedback"
                v-if="error.attachment"
                style="display: block"
            >
                {{ error.attachment[0] }}
            </div>
        </div>
        <div class="form-group">
            <button
                type="submit"
                class="btn btn-primary btn-lg btn-block"
                :disabled="submitting"
            >
                Send Template Request
            </button>
        </div>
    </form>
</template>

<script>
import { HTTP } from "../api";

export default {
    data() {
        return {
            form: {
                title: "",
                details: "",
                attachment: "",
            },
            error: {},
            submitting: false,
            attachment_name: "",
        };
    },
    methods: {
        async onSubmit() {
            this.submitting = true;
            try {
                this.error = {};
                let formData = new FormData();
                Object.keys(this.form).forEach((key) => {
                    if (key === "attachment") {
                        if (this.form.attachment !== "") {
                            formData.append(key, this.form[key]);
                        }
                    } else {
                        formData.append(key, this.form[key]);
                    }
                });
                const header = {
                    headers: {
                        "content-type": "multipart/form-data",
                    },
                };
                await HTTP.post(`/template-requests`, formData, header);
                this.form.title = "";
                this.form.details = "";
                this.form.attachment = "";
                this.attachment_name = null;
                this.$notification.success({
                    message: "Template request submitted",
                    description:
                        "Thanks for submitting a template request. Our team will look into it & try to upload the template.",
                    placement: "bottomRight",
                });
            } catch (error) {
                if (error?.response?.status === 422) {
                    this.error = error.response.data.errors;
                } else if (error?.response?.status === 401) {
                    this.$notification.error({
                        message:
                            error?.response?.data?.message || "Not authorized.",
                        description:
                            error?.response?.data?.description ||
                            "You are not authorized to submit template requests. Only customers have access to submit template requests.",
                    });
                } else {
                    this.$notification.error({
                        message: "Something went wrong!",
                        description: error?.message,
                    });
                }
            }
            this.submitting = false;
        },
        changeFile(event) {
            this.error.attachment = null;
            const file = event.target.files[0];
            this.attachment_name = file.name;
            this.form.attachment = file;
        },
    },
};
</script>
